import { Divider } from "@material-ui/core";
import { Col, Row, Table } from "antd";
import { LIST_CHAT_AGENT_STATUS } from "constant";
import datetimeHelper from "helper/datetime-helper";
import { memo } from "react";
import { useSelector } from "react-redux";

import classes from "./TabChatChannel.module.css";

const TabChatChannel = () => {
  const agentChatReport = useSelector(
    (state) => state.dashboard.agentChatReport
  );
  const chatAgents = useSelector((state) => state.monitor.chatAgents);

  const columns = [
    {
      title: <span style={{ paddingLeft: 24 }}>Tên điện thoại viên</span>,
      dataIndex: "user",
      key: "fullname",
      render: (value) => value?.fullname || "",
    },
    {
      title: <span style={{ paddingLeft: 24 }}>Tài khoản điện thoại viên</span>,
      dataIndex: "user",
      key: "username",
      render: (value) => value?.username || "",
    },
    {
      title: "Hiệu suất",
      dataIndex: "agentPerformance",
      key: "agentPerformance",
      align: "center",
    },
    {
      title: "Nguồn kênh",
      dataIndex: "sourceChannel",
      key: "sourceChannel",
      align: "center",
    },
    {
      title: "Tên kênh",
      dataIndex: "nameChannel",
      key: "nameChannel",
    },
    {
      title: "Tên khách hàng",
      dataIndex: "customer",
      key: "customer",
    },
    {
      title: "Trạng thái ĐTV",
      dataIndex: "statusChatId",
      key: "statusChatId",
      align: "center",
      render: (value) =>
        LIST_CHAT_AGENT_STATUS.find((item) => item.chatAgentsId === value)
          ?.title || "",
    },
    {
      title: "Thời lượng trả lời",
      dataIndex: "processing_chattime",
      align: "center",
      render: (value, record, index) =>
        value ? datetimeHelper.secondToHHMMSS(value) : null,
    },
    {
      title: "Thời gian chờ",
      dataIndex: "waiting_time",
      width: "130px",
      align: "center",
      render: (value) => (value ? datetimeHelper.secondToHHMMSS(value) : null),
    },
  ];

  const chatStatistic = [
    {
      title: "Tổng cuộc chat",
      value:
        (agentChatReport?.doneThread || 0) +
        (agentChatReport?.missedThread || 0),
    },
    {
      title: "Đang chờ",
      value: agentChatReport?.waitingThread || 0,
    },
    {
      title: "Đang trả lời",
      value: agentChatReport?.processingThread || 0,
    },
    {
      title: "Đã trả lời",
      value: agentChatReport?.doneThread || 0,
    },
    {
      title: "Số cuộc chat nhỡ",
      value: agentChatReport?.missedThread || 0,
    },
  ];

  return (
    <div style={{ padding: "0px 10px 10px 10px" }}>
      <div className={classes.title}>Thống kê cuộc chat</div>
      <Divider style={{ marginBottom: 5 }} />
      <Row gutter={16} className={classes.chatInfo__container}>
        {chatStatistic.map((item, index) => (
          <Col key={index} className={classes.chatInfo__col}>
            <div className={classes.chatInfo__item}>
              <div className={classes.total}>{item.value}</div>
              <div className={classes.reportTitle}>{item.title}</div>
            </div>
          </Col>
        ))}
      </Row>
      <div className={classes.title}>Danh sách điện thoại viên</div>
      <Divider style={{ marginBottom: 5 }} />
      <Table
        columns={columns}
        rowKey="_id"
        expandable={{
          childrenColumnName: "chat",
          indentSize: 0,
        }}
        className={classes.tableContainer}
        dataSource={chatAgents}
        pagination={false}
      />
    </div>
  );
};

export default memo(TabChatChannel);
